import {CanActivateFn} from '@angular/router';
import {SessionStore} from '../stores/session.store';
import {RedirectService} from '../services/redirect.service';
import {inject} from '@angular/core';

export const loginGuard: CanActivateFn = () => {
	const session = inject(SessionStore);
	const redirect = inject(RedirectService);

	if (session.isAuthenticated()) {
		redirect.toDefaultRoute();
		return false;
	}

	return true;
};
